// Application Configuration
export const APP_CONFIG = {
  // Set to false to disable user registrations
  ALLOW_SIGNUPS: process.env.REACT_APP_ALLOW_SIGNUPS !== "false",

  // Set to true to show only maintenance/development page
  // Defaults to false so production builds are live
  MAINTENANCE_MODE: process.env.REACT_APP_MAINTENANCE_MODE === "true",

  // Set to false to disable whitelist system (allow all authenticated users)
  REQUIRE_WHITELIST: process.env.REACT_APP_REQUIRE_WHITELIST !== "false",

  // Development mode settings — defaults to false in production
  DEVELOPMENT_MODE: process.env.REACT_APP_DEVELOPMENT_MODE === "true",

  // Admin settings
  ADMIN_EMAILS: [
    "shirlenedymock@mac.com",
    "shirlenedymock@gmail.com",
    "rdymock@gmail.com",
  ],

  // Feature flags
  FEATURES: {
    NEWSLETTER_SIGNUP: true,
    CONTACT_FORM: true,
    ADMIN_DASHBOARD: true,
    // FamilySearch integration is gated off until the API application is
    // approved and production credentials/endpoints are verified.
    // Enable with REACT_APP_ENABLE_FAMILYSEARCH=true once that happens.
    FAMILYSEARCH: process.env.REACT_APP_ENABLE_FAMILYSEARCH === "true",
  },

  // Messages
  MESSAGES: {
    SIGNUP_DISABLED:
      "New user registrations are temporarily disabled while we're working on improvements to the platform.",
    DEVELOPMENT_MODE: "🚧 Development Mode",
  },
};

export default APP_CONFIG;
